<template>
  <div>
    <div v-if="$auth.policies['view-club']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Câu lạc bộ"
            :link="[
              { text: 'Học sinh', href: '#' },
              { text: 'Câu lạc bộ', href: '#' }
            ]"
          />
        </div>
        <v-btn
          v-if="$auth.policies['create-club']"
          class="ml-6"
          depressed
          dark
          color="#0D47A1"
          @click="$refs.clubDialog.openDialog()"
        >
          <v-icon left>add</v-icon>Thêm câu lạc bộ
        </v-btn>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0"> <ClubFilter /> </v-card>
      <v-card outlined class="mx-4 mb-6 elevation-0"> <ClubTable /> </v-card>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
    <ClubDialog ref="clubDialog" />
  </div>
</template>
<script>
import Page403 from '@/views/Page403.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ClubFilter from '../../modules/club/club/ClubFilter.vue'
import ClubTable from '../../modules/club/club/ClubTable.vue'
import ClubDialog from '../../modules/club/club/ClubDialog.vue'
export default {
  components: {
    Page403,
    Breadcrumbs,
    ClubFilter,
    ClubTable,
    ClubDialog
  },
  computed: {},
  methods: {}
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
